module.exports = __webpack_public_path__ + "static/media/italiano_saperedipiù.9fd874c5.png";